import { render } from "./MInfoPublish.vue?vue&type=template&id=f9c540a6&scoped=true"
import script from "./MInfoPublish.vue?vue&type=script&lang=js"
export * from "./MInfoPublish.vue?vue&type=script&lang=js"

import "./MInfoPublish.vue?vue&type=style&index=0&id=f9c540a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c540a6"]])

export default __exports__